<template>
  <div>
    <el-button
      @click="dialogVisible = true"
      size="small"
      type="primary"
    >{{$t('view_test_2500')}}</el-button>
    <el-dialog
      :title="$t('view_test_2500')"
      width="60%"
      :visible.sync="dialogVisible"
    >
      <div>
        <my_checkbox_box
          :options="filterByOptions"
          v-model="filterBy"
        ></my_checkbox_box>
        <my_add_button
          type="goodsList"
          @confirm="confirm"
          :selectIds.sync="selectIds"
        ></my_add_button>
        <my_percentage_slider
          :title="$t('widgets_basic_article_list_edit_373')"
          :value.sync="heightPer"
        ></my_percentage_slider>
        <my_title_index :title="infor.title"></my_title_index>
        <my_title_combination :infor="infor"></my_title_combination>
        <my_input_number
          :value.sync="width"
          titleWidth="0"
        ></my_input_number>
        <my_input_number
          :value.sync="width"
          :title="$t('widgets_basic_article_list_edit_375')"
        ></my_input_number>
        <my_link
          :value.sync="linkURL"
          @setLink="setLink"
        ></my_link>
        <span>{{$t('view_test_2501', [linear_gradient])}}</span>
        <!-- <span>测试页面2</span>-->
        <my_input
          titleWidth="95"
          :title="$t('view_test_2502')"
          :placeholder="$t('view_test_2503')"
          :value.sync="input"
          type="one_level"
        ></my_input>
        <my_slider
          titleWidth="95"
          :title="$t('widgets_basic_article_list_edit_373')"
          :value.sync="height"
          type="one_level"
        ></my_slider>
        <my_select
          titleWidth="95"
          :title="$t('view_form_dialog_add_form_item_187')"
          type="one_level"
          :options="$store.state.options.backgroundType"
          :value.sync="value"
          :placeholder="$t('view_test_2504')"
        ></my_select>
        <my_color
          titleWidth="95"
          type="one_level"
          :color.sync="color"
          :title="$t('widgets_basic_article_list_edit_394')"
        ></my_color>
        <my_color
          titleWidth="95"
          type="one_level"
          :title="$t('view_test_2505')"
          :pattern="pattern2"
          :linear_gradient.sync="linear_gradient"
        ></my_color>
        <my_checkbox
          titleWidth="95"
          type="one_level"
          :title="$t('components_my_border_index_2295')"
          :checkList.sync="checkList"
        ></my_checkbox>
        <my_radio
          titleWidth="95"
          :option="option"
          :selectValue.sync="selectValue"
          :title="$t('view_left_sidebar_page_setting_header_setting_266')"
          :tips="$t('view_test_2506')"
          iconIsShow="right"
        >
        </my_radio>
        <my_radio
          titleWidth="77"
          :selectValue.sync="selectValue2"
          :title="$t('view_left_sidebar_page_setting_header_setting_266')"
          :tips="$t('view_test_2506')"
          iconIsShow="left"
        >
          <div slot="pull_down_control">
            <my_select
              titleWidth="95"
              :title="$t('view_form_dialog_add_form_item_187')"
              :options="$store.state.options.backgroundType"
              :value.sync="value"
              :placeholder="$t('view_test_2504')"
            ></my_select>
            <my_slider
              titleWidth="95"
              :title="$t('widgets_basic_article_list_edit_373')"
              :value.sync="height"
            ></my_slider>
            <my_color
              titleWidth="95"
              :color.sync="color"
              titleWidht="95"
              :title="$t('widgets_basic_article_list_edit_394')"
            ></my_color>
            <my_color
              titleWidth="95"
              :color.sync="color2"
              :title="$t('view_test_2505')"
              :pattern="pattern2"
              :linear_gradient="linear_gradient"
            ></my_color>
            <my_checkbox
              :title="$t('components_my_border_index_2295')"
              :checkList.sync="checkList"
            ></my_checkbox>
          </div>
        </my_radio>
        <my_line_style
          titleWidth="95"
          :title="$t('view_form_dialog_add_form_item_187')"
          type="one_level"
          :options="$store.state.options.lineType"
          :value.sync="borderType"
          :placeholder="$t('view_test_2504')"
        ></my_line_style>
        <my_text_biu
          titleWidth="95"
          :title="$t('view_test_2507')"
          :fsWeight.sync="fsWeight"
          :fsItalics.sync="fsItalics"
          :fsUnderline.sync="fsUnderline"
          type="one_level"
        ></my_text_biu>
        <my_text_align
          titleWidth="95"
          :title="$t('view_test_2508')"
          type="one_level"
          :textAlign.sync="textAlign"
        ></my_text_align>
        <div style="display: flex;justify-content: flex-start">
          <my_text_biu
            titleWidth="95"
            :title="$t('view_test_2509')"
            type="one_level"
            :fsWeight.sync="fsWeight"
            :fsItalics.sync="fsItalics"
            :fsUnderline.sync="fsUnderline"
          ></my_text_biu>
          <my_line_height
            titleWidth="95"
            type="one_level"
            :options="$store.state.options.lineHeight"
            :lineHeight.sync="lineHeight"
          ></my_line_height>
          <my_text_align
            titleWidth="95"
            type="one_level"
            :textAlign.sync="textAlign"
          ></my_text_align>
          <p class="set_icon">
            <span class="setting_icon setting_icon_link"></span>
          </p>
          <p class="set_icon">
            <span class="setting_icon setting_icon_clear"></span>
          </p>
        </div>
        <my_border
          titleWidth="95"
          :radioValue.sync="selectValue3"
          :colorValue.sync="color"
          :sliderValue.sync="height"
          :lineStyleValue.sync="value"
          :checkBoxValue.sync="checkList"
        ></my_border>
        <my_font_size
          titleWidth="95"
          hiddenIsShow="false"
          :radioValue.sync="selectValue4"
          :fontFamily.sync="fontFamily"
          :fontSize.sync="fontSize"
          :colorValue.sync="color"
          :selectColor.sync="selectColor"
          :fsWeight.sync="fsWeight"
          :fsItalics.sync="fsItalics"
          :fsUnderline.sync="fsUnderline"
          :textAlign.sync="textAlign"
        ></my_font_size>
        <my_background
          titleWidth="95"
          hiddenIsShow="false"
          :radioValue.sync="selectValue5"
          :bgType.sync="bgType"
          :colorValue.sync="color"
          :imgUrl.sync="imgUrl"
        ></my_background>
        <my_border
          titleWidth="95"
          :title="$t('widgets_basic_article_classification_edit_324')"
          hiddenIsShow="false"
          :radioValue.sync="selectValue3"
          :colorValue.sync="color"
          :sliderValue.sync="height"
          :lineStyleValue.sync="value"
        ></my_border>
        <span>paddingTop:{{paddingTop}}</span>
        <my_margin
          titleWidth="52"
          :marginTop.sync="paddingTop"
          :marginBottom.sync="paddingBottom"
          :marginLeft.sync="paddingLeft"
          :marginRight.sync="paddingRight"
        ></my_margin>
        <my_img_button
          titleWidth="72"
          :title="$t('view_dialog_index_150')"
          :buttonTitle="$t('view_dialog_index_151')"
          iconIsShow="left"
          tipsWidth="250"
          type="one_level"
          :tips="$t('view_back_top_edit_98')"
          @uploadImg="uploadImg"
          :imgUrl.sync="imgUrl"
        ></my_img_button>
        <my_title
          :inputValue.sync="inputValue"
          :checkboxValue.sync="checkboxValue"
        ></my_title>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">{{$t('view_public_topbar_14')}}</el-button>
        <el-button
          type="primary"
          @click="dialogVisible = false"
        >{{$t('view_public_topbar_15')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import i18n from '../language/index'

import { create_title } from '@/base/titleData';
export default {
  name: "test2",
  data () {
    return {
      heightPer: '10%',
      width: 10,
      linkURL: 'https://www.baidu.com/',
      paddingTop: '10%',
      paddingBottom: '10%',
      paddingLeft: '10%',
      paddingRight: '10%',
      bgType: 'color',
      fontFamily: '',
      selectValue5: 'default',
      selectValue3: 'default',
      selectValue4: 'default',
      selectValue: 'block',
      selectValue2: 'default',
      color: 'rgb(252, 192, 46,1)',
      selectColor: 'rgb(252, 192, 46,1)',
      filterBy: ['noSort', 'industryNews'],
      filterByOptions: [{
        label: i18n.t('widgets_basic_article_list_edit_406'),
        value: 'noSort'
      }, {
        label: i18n.t('widgets_basic_article_list_edit_407'),
        value: 'corporateInfo'
      }, {
        label: i18n.t('widgets_basic_article_list_edit_408'),
        value: 'industryNews'
      }, {
        label: i18n.t('widgets_basic_article_list_edit_409'),
        value: 'technicalArticle'
      }],
      option: [{
        value: 'block',
        label: i18n.t('view_form_dialog_add_form_213')
      },
      {
        value: 'none',
        label: i18n.t('view_back_top_index_105')
      }],
      options: [{
        value: i18n.t('view_test_2510'),
        label: i18n.t('view_test_2511')
      }, {
        value: i18n.t('view_test_2512'),
        label: i18n.t('view_test_2513')
      }, {
        value: i18n.t('view_test_2514'),
        label: i18n.t('view_test_2515')
      }, {
        value: i18n.t('view_test_2516'),
        label: i18n.t('view_test_2517')
      }, {
        value: i18n.t('view_test_2518'),
        label: i18n.t('view_test_2519')
      }],
      fontSize: 12,
      value: '',
      input: '',
      height: 100,
      borderType: 'solid',
      color2: 'rgb(252,100,0)',
      pattern: 'pure_color',
      pattern2: 'linear_gradient',
      linear_gradient: {
        start_color: "rgba(156,40,177,1)",
        end_color: "rgba(0, 0, 0,1)",
        start_pointer: 12,
        end_pointer: 100,
        deg: 90
      },
      checkList: ['top', 'left'],
      fsWeight: 'bold',
      fsItalics: 'normal',
      fsUnderline: 'none',
      textAlign: 'left',
      lineHeight: 10,
      imgUrl: '',
      dialogVisible: false,
      inputValue: i18n.t('view_test_2520'),
      checkboxValue: true,
      infor: {
        title: create_title(i18n.t('widgets_basic_banner_edit_432'))
      },
      selectIds: [1, 2, 3]
    }
  },
  components: {
  },
  methods: {
    uploadImg () {
      this.$store.commit('image_upload/set_showTag', true);
      this.$store.commit('image_upload/set_fileType', 1);
      this.$store.commit('image_upload/set_fileLimit', 1);
      this.$store.state.image_upload.imgFile = (e) => {
        this.imgUrl = e;
        this.$store.state.image_upload.imgFile = null
      }
      console.log(1, this.imgUrl)
    },
    confirm (ids) {
      console.log(ids)
    },
    setLink () {
    }
  },
  computed: {

  },
  watch: {

  },
  mounted () {
  }

}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/test.vue